export default __webpack_public_path__ + "static/media/Minor Brew of Foresight.9838ee7b.jpg";